import { MESSAGE_TYPE } from '@/src/features/message/models/Message.enums'

import { INTENTION_TYPE } from './Intention.enums'

export const intentionMessageTypeMap = {
  [INTENTION_TYPE.INTENTION]: MESSAGE_TYPE.THANKS_INTENTION_PRAYER,
  [INTENTION_TYPE.ARRIVAL]: MESSAGE_TYPE.THANKS_ARRIVAL_INTENTION_PRAYER,
  [INTENTION_TYPE.BIRTHDAY]: MESSAGE_TYPE.THANKS_BIRTHDAY_INTENTION_PRAYER,
} as const
